<template>
  <div>
    <div v-if='ok'>
      <div v-if='!read_only' style='width: 100px;margin-bottom: 10px;'>
        <el-button v-if='!edit' @click='edit=!edit' type='primary'>编辑变量</el-button>
        <el-button v-else @click='edit=!edit' type='primary'>浏览列表</el-button>
      </div>

      <div v-if='read_only' style='width: 100px;margin-bottom: 10px;'>
        <el-button  @click='returnBack' type='primary'>返回</el-button>
      </div>

      <history-table v-if='!edit' :companyId='companyId' :varIds="varIds"></history-table>
      <div v-if='edit'>
        <!-- 搜索部分 -->
        <div style="display: flex;justify-content: center;">
          <el-input style="width: 60%;margin-right: 10px"
                    placeholder="输入变量名称搜索"
                    v-model="variableName"
                    clearable>
          </el-input>
          <el-button icon="el-icon-search" circle @click="initData"></el-button>
        </div>
        <div style="margin-top: 10px;">
          <el-table :data="table" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                    :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
            <el-table-column prop="id" label="id" width="40" show-overflow-tooltip/>
            <el-table-column prop="variableName" label="变量名称" width="200" show-overflow-tooltip/>
            <el-table-column prop="description" label="变量描述" width="200" show-overflow-tooltip/>
            <el-table-column prop="deviceType" label="数据类型" min-width="50" show-overflow-tooltip>
              <template v-slot="scope">
                <span v-if="scope.row.variableType == 0">整数</span>
                <span v-if="scope.row.variableType == 1">小数</span>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="50" show-overflow-tooltip/>
            <!-- <el-table-column prop="lastupdate_time" label="最后一次更新时间" min-width="100" show-overflow-tooltip /> -->
            <el-table-column prop="curValue" label="变量当前值" min-width="50" show-overflow-tooltip/>
            <el-table-column label="操作" width="100">
              <template v-slot="scope">
                <el-button v-if='!checkVariableInList(scope.row.id)' type='success'
                          @click='handleVariable(scope.row.id)'>添加
                </el-button>
                <el-button v-else type='warning' @click='handleVariable(scope.row.id)'>删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import API from "@/../config/api.js";
import historyTable from "./Tables/HistoryTable.vue";
import {generatePath} from "../../../config/redirectWindow";

export default {
  props: ['companyId', 'productId', 'projectId', "data", "read_only","preProductId"],
  components: {
    historyTable
  },
  data() {
    return {
      ok: false,
      edit: false,
      tableData: {},
      varIdList: [],
      varIds: "",
      tableSelect: [], //表格选中列表
      table: [],
      variableName: '', //模糊搜索的变量名称
      header: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }
  },
  async mounted() {
    let data = {
      id: this.productId,  // 页面id
      companyId: this.companyId
    }
    this.$axiosRequest({
      url: API.getProductById,
      method: 'POST',
      data: data,
      header: this.header,
      success: res => {
        if (res.status == 200) {
          this.tableData = JSON.parse(res.data.product.tableData)
          console.log('fuck', res.data);
          this.varIds = this.tableData.varIds;
          var n = this.varIds.split(",");
          console.log(n);
          for (var key in n) {
            if (n[key]) {
              this.$set(this.varIdList, parseInt(n[key]), true);
            }
          }
          console.log(this.varIdList);
          this.ok = true;
        }
      }
    })
    this.initData();
  },
  methods: {
    async returnBack(){
      if(this.preProductId){
        let url = await generatePath(this.preProductId,this.companyId);
        window.location.href = url;
      }
    },
    initData() {
      let data = {
        companyId: this.companyId,
        variableName: this.variableName
      }

      this.$axiosRequest({
        url: API.getVariableList,
        method: 'POST',
        data: data,
        header: this.header,
        success: res => {
          this.table = res.data["variableList"];
        }
      });
    },
    //清空搜索
    clear() {
      this.searchTitle = '';
      this.initData();
    },
    checkVariableInList(index) {
      return this.varIdList[index];
    },
    handleVariable(index) {
      if (!this.varIdList[index]) {
        this.$set(this.varIdList, index, true);
      } else {
        this.$set(this.varIdList, index, false);
      }
      this.updateVariableString();
    },
    updateVariableString() {
      var str = "", flag = false;
      for (var key in this.varIdList) {
        if (this.varIdList[key]) {
          if (flag) {
            str += ",";
          }
          str += key.toString();
          if (!flag) {
            flag = true;
          }
        }
      }
      this.varIds = str;
      var newData = {};
      newData.product_type = 3;
      newData.varIds = str;

      let data = {
        companyId: this.companyId,
        id: this.productId,
        tableData: JSON.stringify(newData),
      }

      this.$axiosRequest({
        url: API.updateProduct,                         //后面可能修改
        method: 'POST',
        data: data,
        header: this.header,
        success: res => {
          if (res.status == 200) {
            if (res.data == -1 || res.data == -2) {
              this.$message({
                message: '未保存成功，请重试！',
                type: 'error',
              });
            } else if (res.data > 0) {
              this.$message({
                message: '修改成功',
                type: 'success',
              });
            }
          }
        }
      })
    }
  },
}
</script>

<style>

</style>
